import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

export default class MemberProvider extends HttpRequest {
  constructor () {
    super(process.env.VUE_APP_API)
  }

  getMember (param) {
    this.setHeader(getAuthToken())
    return this.get(`/members${param}`)
  }

  getMemberById (id) {
    this.setHeader(getAuthToken())
    return this.get(`/members/${id}`)
  }

  getDashBoard () {
    this.setHeader(getAuthToken())
    return this.get('/members/dash-board')
  }

  getMemberSpendingById (id, query) {
    this.setHeader(getAuthToken())
    return this.get(`/members/${id}/spending-log?${query}`)
  }

  getMemberByTel (tel) {
    this.setHeader(getAuthToken())
    return this.get(`/members/${tel}/tel`)
  }

  deleteMember (id) {
    this.setHeader(getAuthToken())
    return this.delete(`/members?id=${id}`)
  }

  updateMember (id, member) {
    this.setHeader(getAuthToken())
    return this.put(`/members/${id}`, member)
  }

  createMember (member) {
    this.setHeader(getAuthToken())
    return this.post('/members', member)
  }

  addMemberSpending (spend) {
    this.setHeader(getAuthToken())
    return this.put('/members/add-spending', spend)
  }
}
